import '.eo{border-left:4px solid var(--gray-200);}.ssr-plugin'
import '.ep{padding-left:1.5rem;}.ssr-plugin'
import '.eq{margin:1rem 0;}.ssr-plugin'
import '.er{color:var(--gray-700);}.ssr-plugin'
import '.es{font-style:italic;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { PropsWithChildren } from 'react'

interface BlockQuoteProps extends PropsWithChildren {
  style?: Style
}

export const BlockQuote = ({ children, style }: BlockQuoteProps) => {
  return (
    <styled.blockquote className="eo ep eq er es"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.blockquote>
  )
}
